export default "__VITE_ASSET__B3pz4cqg__"